// Import Material UI icons
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';

// Define logo and category data
export const logo = 'https://i.ibb.co/s9Qys2j/logo.png';

export const categories = [
  { name: 'New', icon: <HomeIcon />, }, // 2
  { name: 'JS Mastery', icon: <CodeIcon />, }, // 3
  { name: 'Coding', icon: <CodeIcon />, }, // 3
  { name: 'ReactJS', icon: <CodeIcon />, }, // 3
  { name: 'NextJS', icon: <CodeIcon />, }, // 3
  { name: 'Music', icon: <MusicNoteIcon /> }, // 1
  { name: 'Education', icon: <SchoolIcon />, }, // 6
  { name: 'Podcast', icon: <GraphicEqIcon />, }, // 4
  { name: 'Movie', icon: <OndemandVideoIcon />, }, // 5
  { name: 'Gaming', icon: <SportsEsportsIcon />, }, // 5
  { name: 'Live', icon: <LiveTvIcon />, }, // 5
  { name: 'Sport', icon: <FitnessCenterIcon />, }, // 5
  { name: 'Fashion', icon: <CheckroomIcon />, }, // 5
  { name: 'Beauty', icon: <FaceRetouchingNaturalIcon />, }, // 5
  { name: 'Comedy', icon: <TheaterComedyIcon />, }, // 5
  { name: 'Gym', icon: <FitnessCenterIcon />, }, // 5
  { name: 'Crypto', icon: <DeveloperModeIcon />, }, // 5
];

// Demo data
export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png';
